const parseHtmlEntities = (value: string): string =>
  value.replace(/&#([0-9]{1,3});/gi, (_, charCode) => String.fromCharCode(Number(charCode)));

export default parseHtmlEntities;
